<template>
  <header class="topbar">
    <div class="topbar-left">
      <button class="menu-toggle" aria-label="Abrir o cerrar menu" @click="$emit('toggle-sidebar')">
        <svg viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
      </button>
      <BmotikBrand class="desktop-brand" compact />
    </div>
    <div class="topbar-actions">
      <span v-if="company" class="context-copy"><small>Espacio activo</small><strong>{{ company.name }}</strong></span>
      <span class="server-state"><i></i><span>Servidor conectado</span></span>
      <router-link class="profile-link" to="/cuenta" :title="user?.name || 'Mi cuenta'">
        <span class="avatar">{{ initials }}</span>
      </router-link>
    </div>
  </header>
</template>

<script>
import BmotikBrand from '@/components/brand/BmotikBrand.vue';

export default {
  name: 'TopBar',
  components: { BmotikBrand },
  computed: {
    user() { return this.$store.state.user; },
    company() { return this.$store.state.context?.company; },
    initials() {
      const name = this.user?.name || 'BR';
      return name.split(' ').filter(Boolean).map((item) => item[0]).join('').substring(0, 2).toUpperCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar { position: fixed; inset: 0 0 auto; z-index: 900; height: 4.7rem; padding: .7rem clamp(1rem, 2.4vw, 2rem); display: flex; align-items: center; justify-content: space-between; gap: 1rem; border-bottom: 1px solid var(--bm-border); background: rgba(255,255,255,.94); box-shadow: 0 8px 28px rgba(29,29,117,.045); backdrop-filter: blur(18px); }
.topbar-left, .topbar-actions { display: flex; align-items: center; gap: .8rem; }
.menu-toggle { width: 40px; height: 40px; display: grid; place-items: center; border: 1px solid var(--bm-border); border-radius: 10px; color: var(--bm-blue); background: var(--bm-tint); cursor: pointer; }
.menu-toggle svg { width: 20px; height: 20px; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; }
.context-copy { min-width: 0; padding-right: .85rem; display: flex; flex-direction: column; align-items: flex-end; border-right: 1px solid var(--bm-border); }
.context-copy small { color: var(--bm-muted); font-size: .58rem; font-weight: 750; letter-spacing: .08em; text-transform: uppercase; }
.context-copy strong { max-width: 220px; overflow: hidden; color: var(--bm-ink-soft); font-size: .76rem; text-overflow: ellipsis; white-space: nowrap; }
.server-state { min-height: 32px; padding: .35rem .62rem; display: inline-flex; align-items: center; gap: .45rem; border: 1px solid #c8e6d6; border-radius: 8px; color: #156c43; background: #f4fbf7; font-size: .66rem; font-weight: 750; }
.server-state i { width: 7px; height: 7px; border-radius: 50%; background: #20a565; box-shadow: 0 0 0 3px rgba(32,165,101,.12); }
.profile-link { text-decoration: none; }
.avatar { width: 40px; height: 40px; display: grid; place-items: center; border-radius: 12px; color: #fff; background: linear-gradient(145deg, var(--bm-indigo), var(--bm-blue)); font-size: .76rem; font-weight: 850; box-shadow: 0 8px 18px rgba(29,29,117,.18); }
@media (max-width: 760px) { .desktop-brand, .server-state span, .context-copy { display: none; } }
</style>
